import Api from './rest/CompanyEmployee';

export default new Api();
